export default function (query, parametresAExtraire) {
  const parametresExtraits = {};

  for (const nomParametre of parametresAExtraire) {
    if (typeof query[nomParametre] !== 'undefined') {
      parametresExtraits[nomParametre] = query[nomParametre];
    }
  }

  return Object.keys(parametresExtraits).length > 0 ? parametresExtraits : null;
}
